/* eslint-disable react/forbid-prop-types */
/* eslint-disable */

import React from "react";
import PropTypes from "prop-types";

function CardData(props) {
  const { cardDetails, withDate } = props;

  return (
    <ul>
      <li>
        <span className="base_card__bold">رقم القطعة : </span>
        {cardDetails.PARCEL_ID}
      </li>
      <li>
        <span className="base_card__bold">رقم اللوحة : </span>
        {cardDetails.SHEET_NO}
      </li>
      <li>
        <span className="base_card__bold">الحوض : </span>
        {cardDetails.HOD_NAME || cardDetails.HOD_ANAME}
      </li>
      <li>
        <span className="base_card__bold">رقم الحوض : </span>
        {cardDetails.HOD_CODE}
      </li>
      <li>
        <span className="base_card__bold">المنطقة : </span>
        {cardDetails.VELL_NAME || cardDetails.VILL_ANAME}
      </li>
      {withDate && (
        <li>
          <span className="base_card__bold">وقت إنشاء الطلب : </span>
          {cardDetails?.requestDate?.split("T")[0]}
        </li>
      )}
    </ul>
  );
}
CardData.defaultProps = {
  cardDetails: {},
  withDate: false,
};
CardData.propTypes = {
  cardDetails: PropTypes.object,
  withDate: PropTypes.bool,
};

export default CardData;
